import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // This controller is now much simpler - it only handles the toast notification
  // The toggle action is handled by Rails + Turbo Streams

  showToast(event) {
    const remembered = event.detail.remembered
    const message = remembered ? "Added to memories" : "Removed from memories"

    // Create notification element
    const notification = document.createElement("div")
    notification.className = "fixed bottom-4 right-4 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in"
    notification.textContent = message

    document.body.appendChild(notification)

    // Remove after 2 seconds
    setTimeout(() => {
      notification.classList.add("animate-fade-out")
      setTimeout(() => notification.remove(), 300)
    }, 2000)
  }
}
